import { nsauth } from '@isyc-react/auth/i18n/namespaces';
import { nsformfile } from '@isyc-react/form-file/i18n/namespaces';
import { nsoncustomer } from '@isyc-react/oncustomer/i18n/namespaces';
import { nsform } from '@isyc-react/form/i18n/namespaces';
import { nsarchives } from '@isyc-react/archives/i18n/namespaces';
export const preloadNamespaces = [nsform.common, nsarchives.common, nsformfile.common, nsauth.common, nsoncustomer.common];
